/**
 * Alle 20 KI-Prompts aus backend/config/ai_prompts/
 * Gruppiert nach Anwendungsbereich.
 */

export const KI_GROUPS = [
  {
    key: 'complaint_analysis',
    name: 'Reklamations-Analyse',
    color: 'purple',
    prompts: [
      {
        id: 'p01', name: 'Quality-Score',
        description: '0-100 Bewertung der Reklamations-Qualität nach VDA/IATF.',
        rules: 'Gewichtung: D0=5%, D1=5%, D2=20%, D3=10%, D4=25%, D5=15%, D6=10%, D7=5%, D8=5%',
        trafficLight: '≥80 grün · 50-79 gelb · <50 rot',
        endpoint: 'POST /api/complaints/{cid}/ai-quality-check',
        step: 'Alle',
      },
      {
        id: 'p02', name: 'Fehlercode-Zuordnung',
        description: 'Zuordnung von max. 3 Fehlercodes aus dem QM-Fehlerkatalog.',
        rules: 'Max 3 Codes, ausschließlich aus Katalog',
        endpoint: 'POST /api/ai/suggest-error-code', step: 'D2',
      },
      {
        id: 'p03', name: 'Maßnahmenvorschläge',
        description: 'SMART-Maßnahmen für D3/D5/D6/D7 (4 Typen).',
        rules: 'SMART-Kriterien · Sofort 24-72h · Korrektur 7-30 Tage',
        endpoint: 'POST /api/ai/suggest-actions', step: 'D3, D5, D6, D7',
      },
      {
        id: 'p04', name: 'Ursachenanalyse 6M',
        description: '4-8 Ursachen aus 6M-Kategorien (Mensch/Maschine/Material/Methode/Mitwelt/Messung).',
        rules: 'Min. 3 Kategorien, 4-8 Ursachen',
        endpoint: 'POST /api/ai/suggest-causes', step: 'D4',
      },
      {
        id: 'p05', name: 'Vollanalyse D2→D7',
        description: 'Automatische Befüllung D3+D4+D5+D6+D7 ausgehend von D2.',
        endpoint: 'POST /api/ai/analyze-d2-suggest-all', step: 'D2-D7',
      },
      {
        id: 'p06', name: '5-Why-Analyse',
        description: 'Interaktiver 5-Ebenen-Dialog bis zur Root-Cause.',
        rules: 'Runden 1-5 · Runde 5 = Abschluss-Analyse',
        endpoint: 'POST /api/ai/five-why-analysis', step: 'D4',
      },
    ],
  },
  {
    key: 'description_helper',
    name: 'Beschreibungs-Hilfe',
    color: 'blue',
    prompts: [
      {
        id: 'p07', name: 'KI-Kurzbeschreibung',
        description: 'Automatische Kurzfassung der Problembeschreibung.',
        endpoint: 'POST /api/ai/generate-short-description', step: 'D2',
      },
    ],
  },
  {
    key: 'email_ai',
    name: 'E-Mail-KI',
    color: 'cyan',
    prompts: [
      {
        id: 'p09', name: 'E-Mail-Datenextraktion',
        description: 'KI extrahiert Kunde, Artikel, Menge, Problem aus eingehenden E-Mails.',
        endpoint: 'E-Mail-Pipeline (IMAP)', step: 'D0',
      },
      {
        id: 'p10', name: 'E-Mail-Antwort-Generator',
        description: 'Vorschläge für Antwort an Kunden/Lieferanten (mehrsprachig).',
        endpoint: 'E-Mail-Pipeline',
      },
      {
        id: 'p11', name: 'E-Mail-Thread-Merge',
        description: 'Zusammenführung mehrerer E-Mails zum gleichen Vorgang.',
        endpoint: 'E-Mail-Pipeline',
      },
      {
        id: 'p12', name: 'E-Mail-Validierung',
        description: 'Prüfung auf Relevanz, Spam-Filter und Duplikate.',
        endpoint: 'E-Mail-Pipeline',
      },
    ],
  },
  {
    key: 'analytics_ai',
    name: 'Analytics-KI',
    color: 'indigo',
    prompts: [
      { id: 'p13', name: 'Prognose-Analyse', description: 'Forecast für Reklamations-Volumen (Zeitreihe).', endpoint: 'Analytics-Pipeline' },
      { id: 'p14', name: 'Risiko-Bewertung', description: 'Risiko-Score pro Kunde / Produkt / Prozess.', endpoint: 'Analytics-Pipeline' },
      { id: 'p15', name: 'Muster-Erkennung', description: 'Identifikation wiederkehrender Fehler- und Ursachen-Muster.', endpoint: 'Analytics-Pipeline' },
    ],
  },
  {
    key: 'd_step_ai',
    name: 'D-Schritt-KI',
    color: 'green',
    prompts: [
      { id: 'p16', name: 'D6-Wirksamkeitsprüfung', description: 'KI-Vorschläge für messbare Wirksamkeits-Nachweise.', endpoint: 'POST /api/ai/suggest-d6-verification', step: 'D6' },
      { id: 'p17', name: 'Ishikawa-Generator', description: 'Automatische 6M-Ishikawa-Diagramm-Erstellung.', endpoint: 'POST /api/ai/suggest-ishikawa', step: 'D4' },
    ],
  },
  {
    key: 'q2_supplier_ai',
    name: 'Q2 Supplier-KI',
    color: 'amber',
    prompts: [
      { id: 'p18', name: 'Lieferanten-Erkennung', description: 'KI identifiziert betroffenen Zukauf-Lieferanten aus Q1.', endpoint: 'POST /api/supplier-claims/{id}/ai/detect' },
      { id: 'p19', name: 'Report-Bewertung', description: 'KI-Qualitätsscore (0-100) für eingereichte Lieferanten-Reports.', endpoint: 'POST /api/supplier-claims/{id}/ai/evaluate-report' },
      { id: 'p20', name: 'Lieferantenbrief-Generator', description: 'Automatisch generiertes Anschreiben (DE/EN) an Lieferant.', endpoint: 'POST /api/supplier-claims/{id}/ai/generate-letter' },
    ],
  },
  {
    key: 'cost_ai',
    name: 'Kosten-KI',
    color: 'rose',
    prompts: [
      { id: 'p21', name: 'Kostenberechnung', description: 'KI berechnet 7 Kostenarten + Begründung (CoPQ, Material, Lohn, Transport, Prüfung, Entsorgung, Ausfall).', endpoint: 'POST /api/supplier-claims/{id}/ai/suggest-costs' },
    ],
  },
];

export const QUALITY_SCORE_WEIGHTS = [
  { step: 'D0 Stammdaten', weight: '5%' }, { step: 'D1 Team', weight: '5%' },
  { step: 'D2 Problem', weight: '20%' }, { step: 'D3 Sofort', weight: '10%' },
  { step: 'D4 Ursache', weight: '25%' }, { step: 'D5 Korrektur', weight: '15%' },
  { step: 'D6 Wirksamkeit', weight: '10%' }, { step: 'D7 Vorbeugung', weight: '5%' },
  { step: 'D8 Abschluss', weight: '5%' },
];
